export default "__VITE_ASSET__3ea295b9__"